import { render, staticRenderFns } from "./KanbanCard.vue?vue&type=template&id=494e92cd&scoped=true"
import script from "./KanbanCard.vue?vue&type=script&lang=js"
export * from "./KanbanCard.vue?vue&type=script&lang=js"
import style0 from "./KanbanCard.vue?vue&type=style&index=0&id=494e92cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494e92cd",
  null
  
)

export default component.exports